import * as moment from "moment";

export interface Link {
    id: string;
    name: string;
}

export interface TaskModel {
    readonly id: string;
    readonly dateCreated: moment.Moment;
    readonly createdBy: Link;
    readonly caseId: string;
    readonly completed: boolean;
    readonly completedBy: Link | null;
    readonly completedDate: moment.Moment | null;
    readonly actualCompletionDate?: moment.Moment;
    readonly actuallyCarriedOutBy?: Link;
    readonly type: string;
    readonly typeId: string;
    readonly notes: string | null;
    readonly closingNote?: string;
    readonly dueDate: moment.Moment | undefined;
    readonly description: string | null;
    readonly cancelled: boolean;
    readonly actions?: string[];
    readonly appointmentId?: string;
    readonly teamsMeetingLink?: string;
    readonly isVideoAppointmentTask?: boolean;
    readonly isVideoBookAppointmentTask?: boolean;
    readonly didNotAttend?: boolean;
    readonly assignedUsers: Link[];
    readonly assignedUserIds?: string[];
    readonly customer: Link;
    readonly employeeRecord: Link | null;
    readonly doesNotAffectCaseStatus?: true;
    readonly taskCategories?: string[];
    readonly precedingTaskId?: string;
    readonly isBookTask?: boolean;
    readonly earlierAppointmentDate?: moment.Moment;
    readonly isAssignable?: false;
    readonly immunisationTypeTasks?: Link[];
    readonly ppqOutcome?: Link;
}

export interface TasksAndCountModel {
    tasks: TaskModel[];
    totalCount: number;
}

export interface EditTaskCompletionDataModel {
    taskId: string;
    actualCompletionDate: moment.Moment;
    actuallyCarriedOutById: string;
    earlierAppointmentDate?: moment.Moment;
}

export interface TaskToDeleteModel {
    taskId: string;
    comments: string;
}

export enum TaskTypes {
    WriteReportReferralTask = "WriteReportReferralTask",
    InitialWorkAdjustmentDetailsTask = "InitialWorkAdjustmentDetailsTask",
    ManagerToProcessUpdateWorkAdjustmentQuestionnaireTask = "ManagerToProcessUpdateWorkAdjustmentQuestionnaireTask",
    ManagerRebookingConfirmationEmailTask = "ManagerRebookingConfirmationEmailTask",
    ImmunisationClearanceTask = "ImmunisationClearanceTask",
    ManagerFeedbackOnReportTask = "ManagerFeedbackOnReportTask",
    OhCaseConfidentialityChangedTask = "OhCaseConfidentialityChangedTask",
    AmendReportTask = "AmendReportTask",
    DidNotAttendTask = "DidNotAttendTask",
    CompleteHealthSurveillanceQuestionnaireTask = "CompleteHealthSurveillanceQuestionnaireTask",
    EmployeeRecordMergedTask = "EmployeeRecordMergedTask",
    BookRepeatMedicalConsultationTask = "BookRepeatMedicalConsultationTask",
    RepeatMedicalConsultationTask = "RepeatMedicalConsultationTask",
    BookHealthSurveillanceConsultationTask = "BookHealthSurveillanceConsultationTask",
    HealthSurveillanceConsultationTask = "HealthSurveillanceConsultationTask",
    ReviewHealthSurveillanceResultsFromRepeatMedicalTask = "ReviewHealthSurveillanceResultsFromRepeatMedicalTask",
    BookSerumSaveTask = "BookSerumSaveTask",
    HepBBoosterTask = "HepBBoosterTask",
    SerumSaveTask = "SerumSaveTask",
    SourceUnknown6WeekBloodTestTask = "SourceUnknown6WeekBloodTestTask",
    SourceUnknownBook6WeekBloodTestTask = "SourceUnknownBook6WeekBloodTestTask",
    SourceUnknownBook12WeekBloodTestTask = "SourceUnknownBook12WeekBloodTestTask",
    SourceUnknown12WeekBloodTestTask = "SourceUnknown12WeekBloodTestTask",
    SourceUnknownBook24WeekBloodTestTask = "SourceUnknownBook24WeekBloodTestTask",
    SourceUnknown24WeekBloodTestTask = "SourceUnknown24WeekBloodTestTask",
    ManagerSatisfactionFollowUpQuestionnaireTask = "ManagerSatisfactionFollowUpQuestionnaireTask",
    InitialVideoPhysioReferralTask = "InitialVideoPhysioReferralTask",
    InitialTelephonePhysioReferralTask = "InitialTelephonePhysioReferralTask",
    InitialFaceToFacePhysioReferralTask = "InitialFaceToFacePhysioReferralTask",
    FollowUpVideoPhysioReferralTask = "FollowUpVideoPhysioReferralTask",
    FollowUpTelephonePhysioReferralTask = "FollowUpTelephonePhysioReferralTask",
    FollowUpFaceToFacePhysioReferralTask = "FollowUpFaceToFacePhysioReferralTask",
    NoFurtherActionTask = "NoFurtherActionTask",
    AllImmunisationsCompletedForRoleTask = "AllImmunisationsCompletedForRoleTask",
    SystemAdminRemovedReferralFormTask = "SystemAdminRemovedReferralFormTask",
    GeneralAdminTask = "GeneralAdminTask",
    GeneralClinicalTask = "GeneralClinicalTask",
    GeneralBillingTask = "GeneralBillingTask",
    QaReviewMHPTreatmentReferralReportCommentsTask = "QaReviewMHPTreatmentReferralReportCommentsTask",
    QaReviewPhysiotherapyReferralReportCommentsTask = "QaReviewPhysiotherapyReferralReportCommentsTask",
    QaReviewReferralReportCommentsTask = "QaReviewReferralReportCommentsTask",
}

export enum TaskCategories  {
    BookTask = "Book Tasks",
    ReportTask = "Report Tasks",
    ConsultationTask = "Consultation Tasks",
    NotificationTask = "Notification Tasks",
    TriageTask = "Triage Tasks",
    DidNotAttendTask = "Did Not Attend Task",
    GeneralAdminTask = "General Admin Task",
    GeneralClinicalTask = "General Clinical Task",
    GeneralBillingTask = "General Billing Task",
    NoFurtherActionTask = "No Further Action Tasks",
    ActionRequiredTask = "Action Required by Customer/Employee Tasks",
    EvidenceTask = "Evidence Tasks",
    ChaseTask = "Chase Tasks"
}

export enum TaskTypeLabel {
    Clinical = "Clinical",
    Admin = "Admin",
    Customer = "Customer",
    None = ""
}

export const TaskTypeLabelTypes = [
    TaskTypeLabel.Clinical,
    TaskTypeLabel.Admin,
    TaskTypeLabel.Customer
];
